import { useMemo } from "react";

import { useRequest } from "~/v2/api/hooks";
import { queryKeys } from "~/v2/api/queryKeys";
import { type AlgoRouting, getEliteAlgoRouting } from "~/v2/api/rest/elite";

/**
 * Whether the current account may use advanced_instructions (non-retail).
 * Fail closed: loading and errors are treated as not allowed (C19).
 */
export const isAdvancedInstructionsModelAllowed = (
  model: AlgoRouting["model"] | undefined,
): boolean => model != null && model !== "retail";

export const useAdvancedInstructionsAllowed = (
  accountID: string | undefined,
): { allowed: boolean } => {
  const { data, isLoading, isError } = useRequest(
    queryKeys.elite.algoRouting(accountID ?? ""),
    () => getEliteAlgoRouting(accountID as string),
    {
      enabled: !!accountID,
      meta: { showErrorToast: false },
    },
  );

  const allowed = useMemo(() => {
    if (!accountID || isLoading || isError || data == null) {
      return false;
    }
    return isAdvancedInstructionsModelAllowed(data.model);
  }, [accountID, data, isError, isLoading]);

  return { allowed };
};
